<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">{{dialogTitle}}</span>
  <button mat-icon-button (click)="closeDialogDetalleMaterial()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-content>
    <div class="mat-elevation-z4 div-ajusted">
      Nro de Registros : {{ nroRegistros }}
    </div>
    <div class="mat-elevation-z4 div-ajusted div-full">
      <form [formGroup]="materialForm">
        <div class="row">
          <div class="col">
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                      <mat-label>Referencia</mat-label>
                      <input matInput formControlName="reference" required>
                  </mat-form-field>
              </div>
              <div class="col">
                  <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                    <mat-label>Unidad</mat-label>
                    <input matInput formControlName="unitEntity" required>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                  <mat-label>Fecha</mat-label>
                  <input matInput formControlName="date" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                    <mat-label>Descripcion</mat-label>
                    <input matInput formControlName="description" required fxHide.xs>
                    <textarea matInput formControlName="description" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                    <mat-label>Precio</mat-label>
                    <input matInput formControlName="precio" class="input-align-right"  required>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="input-width-small field-wrapper-2em" floatLabel="always">
                  <mat-label>Desperdicio(%)</mat-label>
                  <input matInput formControlName="waste" class="input-align-right" required>
                </mat-form-field>
              </div>
              <div class="col checkbox-margin" fxLayoutAlign.xs="start stretch">
                <section>
                  <mat-checkbox [disabled]="true">I.V.A. Exento</mat-checkbox>
                </section>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column">
              <div class="col checkbox-margin field-wrapper-2em" fxLayoutAlign.xs="start stretch">
                <section>
                  <mat-checkbox formControlName="relateDollar">Relacionar Dólar</mat-checkbox>
                </section>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                    <mat-label>Precio en Dólares</mat-label>
                    <input matInput formControlName="precioEnDolares" class="input-align-right" required>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col div-img-detalle">
            <button mat-raised-button type="button" color="primary" [disabled]="statusPdf" *ngIf="botonPdf"
              class="align-center-middle button-ver-pdf" (click)="openPDF(urlPDF)">
              <span class="text-icon-space">Ver PDF</span>
            </button>
            <div style="margin-top: 20px;" *ngIf="!botonPdf"></div>
            <img src={{urlImage}} width="120px" height="130px">
            <button mat-raised-button type="button" color="primary" [disabled]="statusSpecification" class="align-center-middle button-ver-pdf" (click)="openSpecification(specification)">
              <span class="text-icon-space">Ver Especificaciones</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row-flex div-nac-imp-van field-wrapper-2em" fxLayout.xs="column">
              <div class="col">
                <ng-container>
                  <div class="row">
                    <mat-radio-group aria-label="Select an option" formControlName="isNational">
                      <mat-radio-button value="nacional">Nacional</mat-radio-button>
                      <mat-radio-button value="importado">Importado</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </ng-container>
              </div>
              <div class="col margin-left-5vw">
                <section class="align-center-middle margin-left-5vw" style="padding-top: 10px;padding-right: 15px;">
                  <mat-checkbox formControlName="bringsVan"> Aporta V.A.N </mat-checkbox>
                </section>
              </div>
              <div class="col margin-left-1vw">
                <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always"
                  style="padding-top: 10px;padding-right: 15px;">
                  <mat-label>V.A.N. </mat-label>
                  <input matInput formControlName="van" class="input-align-right" required>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row-flex" fxLayout.xs="column">
            <div class="col">
              <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>Comentario </mat-label>
                  <input matInput formControlName="commentary" required>
              </mat-form-field>
            </div>
          </div>
          <div class="row-flex" fxLayout.xs="column">
            <div class="col">
              <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>Familia B.C.V. </mat-label>
                  <input matInput formControlName="materialFamilyEntity" required fxHide.xs>
                  <textarea matInput formControlName="materialFamilyEntity" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="row-flex" fxLayout.xs="column">
            <div class="col">
              <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>Agrupación </mat-label>
                  <input matInput formControlName="materialGroupingEntity" required fxHide.xs>
                  <textarea matInput formControlName="materialGroupingEntity" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="row-flex" formGroupName="proveedor" fxLayout.xs="column">
            <div class="col">
              <mat-form-field appearance="outline" class="full-width field-wrapper-2em" floatLabel="always">
                  <mat-label>Proveedor </mat-label>
                  <input matInput formControlName="razonSocial" required>
                  <button *ngIf="supplierExists" matSuffix mat-icon-button aria-label="Clear"
                    (click)="openProviderDetails(materialForm.controls['proveedor'])">
                    <mat-icon>search</mat-icon>
                  </button>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
